import { query, destroy, post, put, patch } from '@/services/api/backendGateway'

const CARD_API = '/card/'

export async function fetchCardsByFolder(folderId, { step = null, updateDay = false } = {}) {
  return (await query(CARD_API, { folder: folderId, step, updateDay })) || []
}

export async function fetchCardById(cardId) {
  return query(CARD_API, { id: cardId })
}

export async function searchCardsByKeyword(keyword, userId) {
  return (await query(CARD_API, { search: keyword, user: userId })) || []
}

export async function fetchDashboardCardStats() {
  return (await query(CARD_API, { dashboard: 'true' })) || {}
}

export function deleteCardById(cardId) {
  return destroy(CARD_API, { id: cardId })
}

export function createCard(payload) {
  return post(CARD_API, payload)
}

export function updateCard(payload) {
  return put(CARD_API, payload)
}

export function patchCard(payload) {
  return patch(CARD_API, payload).then(r => r?.data?.response)
}

export function importCardsToFolder(folderId, cards) {
  return post(CARD_API, {
    cards: JSON.stringify(cards),
    folder: folderId
  })
}
